module.exports = __webpack_public_path__ + "media/images/restaurant/index_hero_img_pc-36cf6e6e2e78518f2b44894ef254cdb3.jpg";